import { useEffect } from "react";

export const NavigationButtons = ({
  isFirstStep,
  isLastStep,
  handlePrevious,
  handleNext,
  isLoading,
  onComplete,
  isCompleted,
}) => {
  return (
    <div className="d-flex flex-row justify-content-center align-items-center gap-3">
      <button
        className={`btn-1 ${isFirstStep ? "btn-1-primary" : "btn-1-basic"}`}
        onClick={handlePrevious}
        // disabled={isFirstStep || isLoading}
        style={{
          cursor: isFirstStep || isLoading ? "not-allowed" : "pointer",
          opacity: isFirstStep || isLoading ? 0.5 : 1,
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.825 9L9.425 14.6L8 16L0 8L8 0L9.425 1.4L3.825 7H16V9H3.825Z"
            fill="#008CFF"
          />
        </svg>
        Previous
      </button>
      <button
        className={`btn-1 ${isLastStep ? "btn-1-primary" : "btn-1-basic"}`}
        onClick={isLastStep && onComplete ? onComplete : handleNext}
        disabled={isLoading}
        style={{
          cursor: isLoading ? "not-allowed" : "pointer",
          opacity: isLoading ? 0.5 : 1,
        }}
      >
        {isLoading ? (
          "Submitting..."
        ) : isLastStep ? (
          isCompleted ? (
            "Completed"
          ) : (
            "Complete"
          )
        ) : (
          <>
            Next{" "}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ transform: "rotate(180deg)" }}
            >
              <path
                d="M3.825 9L9.425 14.6L8 16L0 8L8 0L9.425 1.4L3.825 7H16V9H3.825Z"
                fill="#008CFF"
              />
            </svg>
          </>
        )}
      </button>
    </div>
  );
};

export const MultiStepContainer = ({
  steps = [],
  currentStepIndex = 0,
  setCurrentStepIndex,
  totalSteps = 0,
  submitStepAnswers,
  weekId,
  isSubmitting = false,
  onComplete,
  isCompleted = false,
}) => {
  const handleNext = async () => {
    if (currentStepIndex < steps.length - 1) {
      // Submit current step answers before moving to next
      const submitted = await submitStepAnswers(currentStepIndex);
      if (submitted) {
        setCurrentStepIndex(currentStepIndex + 1);
      }
    }
  };

  const handlePrevious = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  const isFirstStep = currentStepIndex === 0;
  // Step 10 (index 9) is always the last step
  const isLastStep = currentStepIndex === 8;

  return (
    <div
      className="d-flex flex-column"
      style={{
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: currentStepIndex === 7 ? "" : "720px",
      }}
    >
      {/* Step Content - Scrollable */}
      <div className="weekly-warmap-steps-content">
        {steps[currentStepIndex]}
      </div>

      {/* Navigation Buttons - Bottom Center */}
      <div className="weekly-warmap-navigation-container">
        <NavigationButtons
          isFirstStep={isFirstStep}
          isLastStep={isLastStep}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          isLoading={isSubmitting}
          onComplete={onComplete}
          isCompleted={isCompleted}
        />
      </div>
    </div>
  );
};
